<div class="row container_fieldset" *ngIf="isConfigurationEnabled">
  <div class="col-sm-12">
<fieldset class="form-group">
  <legend>Dati protocollazione</legend>
  <div>

    <div *ngFor="let formField of formFields" [ngClass]="formField.size">
      <dynamic-form-field [form]="form"
                          [question]="formField"
                          (onChangeValue)="onFormFieldEvent($event)"/>
    </div>
  </div>
  <div>
    <div *ngIf="showCerca" class="col-sm-12">
      <div class="form-group label">
        <!-- <label class="question-label"></label> -->
      </div>
      <div class="form-group"  *ngIf="!dataView">
        <button  *ngIf="!isProtocolNumber" class="btn btn-primary col-sm-4 col-sm-offset-8 margin-bottom" type="button" (click)="onSearchButton($event)">Cerca o Inserisci</button>
        <button  *ngIf="isProtocolNumber"  class="btn btn-primary col-sm-4 col-sm-offset-8 margin-bottom" type="button" (click)="onCleanButton()">Pulisci campi</button>
      </div>
      <div class="form-group"  *ngIf="dataView">
        <button  class="btn btn-primary col-sm-4 col-sm-offset-8 margin-bottom" type="button" (click)="onCleanButton()">Pulisci campi</button>
      </div>
    </div>
  </div>
</fieldset>
</div>
</div>
